export default "__VITE_ASSET__CL88Zs62__"